import React, { useEffect, useState } from 'react';
import { Box, TextField, withStyles } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { filters } from './styles';
import { useReportFilterItems } from '../../../hooks/reportFilterItems';

function ServicesFilter({ classes, label, handleFilterChange, filters }) {
    const { serviceList } = useReportFilterItems();
    const [selectedItems, setSelectedItems] = useState([]);

    useEffect(() => {
        if (serviceList.length > 0) {
            const value = filters['services'];
            if (value) {
                setSelectedItems(value.map(sv => serviceList.find(s => s.value === sv.value)));
            }
        }
    }, [filters, serviceList]);

    const handleChange = (_, items) => {
        handleFilterChange({
            services: items
        });
        setSelectedItems(items);
    };

    return (
        <Box marginTop={4}>
            <Autocomplete
                multiple
                className={classes.autocomplete}
                options={serviceList}
                value={selectedItems}
                onChange={handleChange}
                label={label}
                getOptionLabel={option => option.label}
                renderInput={params => (
                    <TextField
                        {...params}
                        label={label}
                        variant="outlined"
                        InputProps={{
                            ...params.InputProps,
                            classes: {
                                input: classes.autocompleteInputProps
                            }
                        }}
                        InputLabelProps={{
                            ...params.InputLabelProps,
                            className: classes.autocompleteLabelProps
                        }}
                    />
                )}
                renderOption={option => {
                    return <p className={classes.autocompleteOptions}>{`${option.label}`}</p>;
                }}
                ChipProps={{ className: classes.autocompleteChipProps }}
            />
        </Box>
    );
}

export default withStyles(filters)(ServicesFilter);
